<template>
  <div>
    <!-- 安检记录 -->
    <div class="content1">
      <div class="all">
        <div class="table" >
          <!-- <el-button  size="small" @click="backtrack">返回</el-button> -->
          <!--数据表格-->
          <el-table
              ref="tableList"
              :data="buildings"
              style="width: 100%; margin: 15px 0"
              border
              height="calc(100vh - 183px)"
              :stripe="true"
              :header-cell-style="{
              color: '#333',
              fontFamily: 'MicrosoftYaHeiUI',
              fontSize: '14px',
              fontWeight: 900,
              background: '#f8f8f9',
              textAlign:'left',
            }"
          >
              <el-table-column type="index" label="序号" width="70" > </el-table-column>
              <el-table-column prop="dataCode" label="工单编号"  show-overflow-tooltip></el-table-column>
              <el-table-column prop="userName" label="用户名称" show-overflow-tooltip></el-table-column>
              <el-table-column prop="contact" label="联系人"  show-overflow-tooltip></el-table-column>
              <el-table-column prop="userPhone" label="电话"  show-overflow-tooltip></el-table-column>
              <el-table-column prop="userTypeName" label="用户分类"  show-overflow-tooltip></el-table-column>
              <el-table-column prop="addrName" label="片区"  show-overflow-tooltip></el-table-column>
              <el-table-column prop="address" label="地址" show-overflow-tooltip></el-table-column>
              <el-table-column prop="deptName" label="负责部门"  show-overflow-tooltip></el-table-column>
              <el-table-column prop="inspectorName" label="安检员"  show-overflow-tooltip></el-table-column>
              <el-table-column prop="safetyResults" label="安检结果" show-overflow-tooltip>
                <template slot-scope="{row}">
                  <span v-if="row.safetyResults==1">正常安检</span>
                  <span v-if="row.safetyResults==2">到访不遇</span>
                  <span v-if="row.safetyResults==3">拒绝安检</span>
                  <span v-if="row.safetyResults==4">停用</span>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="工单状态" show-overflow-tooltip>
                <template slot-scope="{row}">
                  <span v-if="row.statusFlag==1">已完成</span>
                  <span v-if="row.statusFlag==2">未完成</span>
                </template>
              </el-table-column>
              <el-table-column prop="checkTime" label="检查时间"  show-overflow-tooltip></el-table-column>
              <el-table-column prop="inspectionTime" label="检查时长"  show-overflow-tooltip></el-table-column>
              <el-table-column prop="createBy" label="操作" show-overflow-tooltip>
                <template slot-scope="{ row }">

                  <el-button size="mini"  @click="examine(row)" type="primary"> 查看 </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="searchBox.size"
                :current-page="searchBox.current"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            >
            </el-pagination>
        </div>
      </div>
    </div>
    
  </div>
</template>


<script>
import  {securityCheckRecordPageList} from '../../../RequestPort/intranet/index'
export default {
  name: "lockout",
  data(){
    return{
      // 查询条件
      searchBox:{
        current:1,
        size: 100
      },
      total:null,
      // 列表数据
        buildings: [
          {
            addressName: '',
            companyId: '',
            addressAttr: '',
            floorType: '',
            buildingCategoryId: '',
            generalStatus: '',
            id:0
          }
        ],
    }
  },
  mounted() {
    this.loadList(this.searchBox)
  },
  methods:{
    /**
     * 返回
     */
    backtrack(){
      this.$router.back(-1)
    },
    examine(row){
      this.$router.push({
          path: "/home/record/recordSecurityInfo",
          query: { id: row.dataId },
        });
    },
    /**
     * 更换条数
     */
    handleSizeChange(val){
      this.searchBox.current = 1
      this.searchBox.size = val
      this.loadList(this.searchBox)
    },
    /**
     * 更换页码
     */
    handleCurrentChange(val){
      this.searchBox.current = val
      this.loadList()
    },
    /**
     * 获取列表
     */
    loadList(obj){
        if(obj){
          this.searchBox.current = 1
        }
        this.searchBox.userId = this.$route.query.id
        securityCheckRecordPageList(this.searchBox).then(res=>{
          this.buildings = res.data.records;
          this.total = res.data.total;
        })
    },
  }
}
</script>

<style lang="less" scoped>
::v-deep .el-upload--picture-card{width:100px;height:100px;line-height:100px}
::v-deep .el-upload-list--picture-card .el-upload-list__item{width:100px;height:100px;line-height:100px}
.detil-code{
  padding-left: 10px;
  font-size: 16px;
  height: 26px;
  line-height: 16px;
  color: #000000;
  position: relative;
}
.detil-code:before{
  content: '';
  position: absolute;
  width: 3px;
  height: 16px;
  background-color: #007AFF;
  top: 0;
  left: 0;
}
.content {
  background: #f3f4f8;
  width: 100%;
  border-radius: 6px;
  padding: 10px;
}
.SearchBar {
  /* border: 1px solid #ecedf1; */
  border-radius: 5px;
  margin: 10px;
  padding-top: 1%;
  padding-bottom: 1%;
  background-color: #ffffff;
}
.SearchBtn{
  margin-left: 10px;
}
.table {
  padding: 10px;
  border-radius: 5px;
  margin: 10px;
  background-color: #ffffff;
}
.el-radio{
  margin-right:0;
}
.el-form-item{
  margin-bottom:0;
}
</style>